import { render, staticRenderFns } from "./Drimmer.vue?vue&type=template&id=0f6b0d73&scoped=true"
import script from "./Drimmer.vue?vue&type=script&lang=js"
export * from "./Drimmer.vue?vue&type=script&lang=js"
import style0 from "./Drimmer.vue?vue&type=style&index=0&id=0f6b0d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b0d73",
  null
  
)

export default component.exports